<template>
	<div class="appointment">
		<div class="appointmentTime">选择咨询时间(每次{{60/limitNum}}分钟，可多选，用户首次预约建议咨询时长45分钟以上)</div>
		<div class="changeTime">
			<el-button v-if="showLast" @click="selectWeek('last')" icon="el-icon-caret-left"></el-button>
			<el-button v-else></el-button>
			<span class="time">{{ time }}</span>
			<el-button @click="selectWeek('next')" icon="el-icon-caret-right"></el-button>
		</div>

		<div class="appTime">
			<div class="timeWeek">
				<div v-for="(day,index) in appointArr" class="week" :key="'week_'+index">
					<div class="weekDay">
						<span>{{ day.date.substr(-5) }}</span>
						<span>{{ day.dayOfWeek }}</span>
					</div>
					<div v-for="(item,ind) in day[day.date]" :key="'day_'+ind" class="date">
						<template v-if="item.isAvailable == 0">
							<template v-if="new Date().getTime() < item.longtime">
								<div class="appoint-slot-div" @click="selectChoose($event,item)"
									:class="item.isAvailable == 1?'disabled':''"
									:key="`limitSlot_${item.date}_${ind}`">
									<span>{{ind}}</span>
								</div>
								<!--								</template>-->
							</template>
							<template v-else>
								<div class="appoint-slot-div disabled"
									:key="`limitSlot_${item.date}_${ind}`">
									<span>{{ ind }}</span>
									<!--									<span style="width: 33px">~</span>-->
									<!--									<span>{{ ind.substr(-5) }}</span>-->
								</div>
							</template>
						</template>
						<div v-else class="appoint-slot-div disabled"><span>{{ ind }}</span>
							<!--							<span style="width: 33px">~</span>-->
							<!--							<span>{{ ind.substr(-5) }}</span>-->
						</div>
					</div>
					<template v-if="!day[day.date]">
						<div class="date">
							<div class="appoint-slot-div disabled">不可预约</div>
						</div>
					</template>
				</div>

			</div>
		</div>
		<!--<div class="appTime">
			<div class="timeWeek">
				<div v-for="(day,index) in appointArr" class="week" :key="'week_'+index">
					<div class="weekDay">
						<span>{{ day.date.substr(-5) }}</span>
						<span>{{ day.dayOfWeek }}</span>
					</div>
					<div v-for="(item,ind) in day[day.date]" :key="'day_'+ind" class="date">
						<template v-if="item.isAvailable">
							<template v-if="new Date().getTime() < item.startDateTime">
								<template v-for="limitInd in limitNum">
									<div class="appoint-slot-div" @click="selectChoose($event,item)"
										:class="(item.offIndex && item.offIndex.indexOf(limitInd)>-1)?'disabled':''"
										:key="`limitSlot_${ind}_${limitInd}`"
										:date-end="ind.substr(0, 3) + slotEndMap[limitNum][limitInd-1]"
										:data-date="day.date+' '+ind.substr(0, 3) + slotMap[limitNum][limitInd-1]">
										<span>{{ ind.substr(0, 3) + slotMap[limitNum][limitInd-1] }}</span>
									</div>
								</template>
								&lt;!&ndash;								</template>&ndash;&gt;
							</template>
							<template v-else>
								<template v-for="limitInd in limitNum">
									<div class="appoint-slot-div disabled"
										:class="(item.offIndex && item.offIndex.indexOf(limitInd)>-1)?'disabled':''"
										:key="`dis_limitSlot_${limitInd}`">
										<span>{{ ind.substr(0, 3) + slotMap[limitNum][limitInd-1] }}</span>
										&lt;!&ndash;									<span style="width: 33px">~</span>&ndash;&gt;
										&lt;!&ndash;									<span>{{ ind.substr(-5) }}</span>&ndash;&gt;
									</div>
								</template>
							</template>
						</template>
						<div v-else class="appoint-slot-div disabled"><span>{{ ind.substr(0, 5) }}</span>
							<span style="width: 33px">~</span>
							<span>{{ ind.substr(-5) }}</span>
						</div>
					</div>
					<template v-if="!day[day.date]">
						<div class="date">
							<div class="appoint-slot-div disabled">不可预约</div>
						</div>
					</template>
				</div>

			</div>
		</div>-->

		<div class="selectedTime">
			<p><span class="tit">已选预约时间：</span></p>
			<div class="choosed-div">{{ choosed.show }}</div>
		</div>
	</div>

</template>

<script>
  import base from '@/api/common';

  export default {
    name: "appointment",
    props: {
      account: {
        type: String,
        default: ''
      },
      selectedNumLimit: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        time: '', // 当前展示时间月份 例：2021年03月、2021年03月~2021年04月
        appointArr: [],// 可预约时间段list
        choosed: {},// 已选信息
        choosed_list: [],// 已选择时间戳list
        startTime: new Date().setHours(0, 0, 0, 0), // 默认为当天0点的毫秒值，每次请求成功后，重新赋值
        limitNum: 1,// 默认1，从后台获取后更新
      }
    },
    beforeMount() {
      let vm = this;
      let choosed = sessionStorage.choosed;
      if (choosed == undefined) {
        vm.state = 1;
      } else {
        vm.choosed = JSON.parse(choosed);
        // vm.appoint.payAmount = vm.choosed.payAmount;
      }

      this.getData();
    },
    mounted() {
    },
    methods: {
      // 检查可选时间是否够7天，不够补空
      checkList(arr, dateArr) {
        if (arr.length < 7) {// 不足7天，可能有x天没有预约时间点，需补充连续时间段
          for (let i = 0; i < dateArr.length; i++) {
            if (arr[i] == undefined || (arr[i] && arr[i].date != dateArr[i])) {
              let tmpkey = dateArr[i];
              let obj = {
                date: tmpkey,
                dayOfWeek: '周' + '日一二三四五六'.charAt(new Date(tmpkey).getDay())
              }
              obj[tmpkey] = {};
              arr.splice(i, 0, obj);
              this.checkList(arr, dateArr);
            }
          }
        }
      },

      // 获取数据
      getData() {
        let vm = this;

        this.$ajax.post(base.api.appoint.appointArr, {
          account: vm.account,
          starttime: vm.startTime
        })
          .then((res) => {
            if (res.data.status == 'success') {

              vm.limitNum = res.data.data.limitNum;

              let starttime = vm.startTime;
              let endtime = vm.startTime + 7 * 24 * 60 * 60 * 1000 - 1000;
              const startMonth = new Date(starttime).Format('yyyy年MM月');
              const endMonth = new Date(endtime).Format('yyyy年MM月');
              vm.time = startMonth == endMonth ? startMonth : startMonth + ' ~ ' + endMonth;

              // 清空已选数据
              document.querySelectorAll('.appoint-slot-div.active').forEach((item) => {
                item.className = item.className.replace('active', '')
              });
              vm.choosed_list = [];
              vm.choosed = {};
              let treeMap = res.data.data.treeMap;


              let tmp = '';
              let dateArr = [];
              let slotArr = [];
              let tmp_yyyyMMdd = '';
              let dayOfWeek = '';
              const weekCh = '日一二三四五六';
              Object.keys(treeMap).forEach((longtime) => {
                longtime = parseInt(longtime);
                tmp_yyyyMMdd = new Date(longtime).Format('yyyy-MM-dd');

                const tmp_HHmm = new Date(longtime).Format('HH:mm');
                dayOfWeek = new Date(longtime).getDay();
                if (tmp_yyyyMMdd !== tmp) {
                  // console.log('tmp_yyyyMMdd !== tmp',tmp_yyyyMMdd, tmp)
                  if (tmp) {
                    let obj = {date: tmp, dayOfWeek: '周' + weekCh.charAt(dayOfWeek - 1 < 0 ? 6 : dayOfWeek - 1)};
                    obj[tmp] = slotArr;
                    // console.log('push', tmp,slotArr)
                    dateArr.push(obj);
                  }
                  slotArr = {};
                  slotArr[tmp_HHmm] = {longtime: longtime, isAvailable: treeMap[longtime]};
                  tmp = tmp_yyyyMMdd;
                } else {
                  slotArr[tmp_HHmm] = {longtime: longtime, isAvailable: treeMap[longtime]};
                }
              });

              let obj = {date: tmp_yyyyMMdd, dayOfWeek: '周' + weekCh.charAt(dayOfWeek)};
              obj[tmp_yyyyMMdd] = slotArr;
              dateArr.push(obj);

              let arrList = [];
              for (let i = 0; i < 7; i++) {
                arrList.push(new Date(vm.startTime + i * 24 * 60 * 60 * 1000).Format("yyyy-MM-dd"));
              }
              vm.checkList(dateArr, arrList);

              const unAppointableMap = JSON.parse(res.data.data.unAppointableMap || "{}") || {}

              // unAppointableMap["周一"] = ['480-690', '840-1050']
              // unAppointableMap["周二"] = ['840-1050']
              // unAppointableMap["周三"] = ['480-690', '840-1050']
              // unAppointableMap["周四"] = []
              // unAppointableMap["周五"] = ['480-690', '840-1050']
              // unAppointableMap["周六"] = []
              // unAppointableMap["周日"] = []

              Object.keys(unAppointableMap).forEach(key => {
                if (unAppointableMap[key].length > 0) {
                  const list = []
                  unAppointableMap[key].forEach(timerange => {
                    let starttime = new Date().setHours(0, parseInt(timerange.split('-')[0]), 0, 0)
                    const endtime = new Date().setHours(0, parseInt(timerange.split('-')[1]), 0, 0)
                    for (; ;) {
                      list.push(new Date(starttime).Format("HH:mm"));
                      starttime += 60 / vm.limitNum * 60 * 1000
                      if (starttime >= endtime) {
                        break
                      }
                    }
                  })
                  unAppointableMap[key] = list
                }
              });

              // console.log(unAppointableMap);

              dateArr.forEach(item => {
                const dateObj = item[item['date']]
                const unAppointableList = unAppointableMap[item.dayOfWeek]
                // console.log(item.dayOfWeek, unAppointableList)
                if (unAppointableList && unAppointableList.length > 0) {
                  unAppointableList.forEach(hhmm => {
                    if (!dateObj[hhmm]) {
                      dateObj[hhmm] = {
                        isAvailable: 1
                      }
                    }
                  })
                }
                let newobj = {}
                let temp = Object.keys(dateObj).sort()
                temp.forEach(key => {
                  newobj[key] = dateObj[key]
                })
                item[item['date']] = newobj;
              })


              vm.appointArr = dateArr;
              // console.log(dateArr);

              /*const startHour = 8, endHour = 17;
              let startlongtime = new Date().setHours(startHour, 0, 0)
              const endtlongime = new Date().setHours(endHour, 0, 0)
							const unAppointableList = []
              for (; ;) {

                console.log(startlongtime, new Date(startlongtime).Format("HH:mm"));
                unAppointableList.push(new Date(startlongtime).Format("HH:mm"));
                startlongtime += 60 / vm.limitNum * 60 * 1000
                if (startlongtime >= endtlongime) {
                  break
                }
              }

              dateArr.forEach(item => {
                const dateObj = item[item['date']]
                const unAppointableList = unAppointableMap[dateObj.dayOfWeek]
                if(unAppointableList && unAppointableList.length> 0) {
                  unAppointableList.forEach(hhmm => {
                    if (!dateObj[hhmm]) {
                      dateObj[hhmm] = {
                        isAvailable: 1
                      }
                    }
                  })
								}
              })

              dateArr.forEach(item => {
                let newobj = {}
                let temp = Object.keys(item[item['date']]).sort()
								temp.forEach(key => {
								  newobj[key] = item[item['date']][key]
								})
                item[item['date']] = newobj
                console.log(temp);
              })*/
            }
          });
      },

      // 切换日期
      selectWeek(type) {
        let addDay;
        if (type == 'last') {// 上一周
          addDay = -7;
        } else if (type == 'next') {// 下一周
          addDay = 7;
        } else {
          return;
        }
        let vm = this;
        vm.startTime = vm.startTime + addDay * 24 * 60 * 60 * 1000;
        vm.getData();

      },

      // 选中时间
      selectChoose(event, item) {
        let vm = this;
        if ($(event.currentTarget).hasClass('disabled')) {
          return;
        }
        if ($(event.currentTarget).hasClass('active')) {// 点击的是已经选中的
          let time = item.longtime;
          if (vm.choosed_list.indexOf(time) !== 0 && vm.choosed_list.indexOf(time) !== vm.choosed_list.length - 1) {//选择的是中间的时间段，从该index往后全清掉
            let ind = vm.choosed_list.indexOf(time);
            vm.choosed_list.splice(vm.choosed_list.indexOf(time), vm.choosed_list.length - vm.choosed_list.indexOf(time));
            document.querySelectorAll('.appoint-slot-div.active').forEach((item, index) => {// 已选list
              if (index >= ind) {
                // console.log('removeclass', item)
                item.className = item.className.replace('active', '');
              }
            })
            // console.log('****** vm.choosed_list', vm.choosed_list)
            // return false;
          } else {
            vm.choosed_list.splice(vm.choosed_list.indexOf(time), 1);
            $(event.currentTarget).removeClass('active');
            if (vm.choosed_list.length == 0) {
              vm.choosed = {};
              return;
            }
          }
        } else {
          if (vm.selectedNumLimit && vm.choosed_list.length >= vm.selectedNumLimit) {
            vm.$message.warning("预约时间段已超出限制");
            return;
          }

          const timeOffset = 60 * 60 * 1000 / vm.limitNum;
          if (vm.choosed_list.length == 0) {
            vm.choosed_list = [...vm.choosed_list, item.longtime].sort(((a, b) => a - b));
          } else {
            let someResult = vm.choosed_list.some((time) => {
              return Math.abs(time - item.longtime) === timeOffset
            });
            if (!someResult) {// 不符合连续规则
              vm.$message.warning("请选择连续时间段");
              return false;
            }
            vm.choosed_list = [...vm.choosed_list, item.longtime].sort(((a, b) => a - b));
          }
          $(event.currentTarget).addClass('active');
        }

        let startDateStr = new Date(vm.choosed_list[0]).Format('yyyy-MM-dd HH:mm - ');
        let endDateStr = new Date().parseDate(vm.choosed_list[vm.choosed_list.length - 1] + 60 * 60 * 1000 / vm.limitNum - 60 * 1000).Format('yyyy-MM-dd HH:mm');
        let showdate = startDateStr + endDateStr;
        if (startDateStr.startsWith(endDateStr.substr(0, 11))) {
          showdate = startDateStr + endDateStr.substr(-5);
        }

        vm.choosed = {
          appointDate: new Date(vm.choosed_list[0]).Format('yyyy-MM-dd'),
          appointSlot: new Date(vm.choosed_list[0]).Format('H'),
          show: showdate,

          appointStartTime: startDateStr.substr(0, 16),
          appointStartLongtime: vm.choosed_list[0],
          appointEndTime: endDateStr,
          appointEndLongtime: vm.choosed_list[vm.choosed_list.length - 1] + 60 / vm.limitNum * 60 * 1000 - 1000,
          slotNum: vm.choosed_list.length,
          endSlot: new Date(vm.choosed_list[vm.choosed_list.length - 1] + 60 * 60 * 1000 / vm.limitNum - 1000).Format('H'),
        };
        vm.$emit('selectCBK', vm.choosed)
      },
    },
    computed: {
      showLast() {
        if (this.startTime > new Date().setHours(0, 0, 0, 0)) {
          return true
        }
        return false
      }
    }
  }
</script>

<style lang="scss" scoped>
	@import '../../assets/css/appointment.scss';
</style>
